import React, { Component } from 'react';
import $ from 'jquery';

class ContinueModal extends Component{

    componentDidMount(){
        this.closeAction();
    }

    closeConfirm = async () => {
        $('#continueModal').modal('hide');  
    }

    closeAction = () => {
        $('#continueModal').on('hidden.bs.modal', function () {
        });
    };
    
    Continue =()=>{
        const {newOrderModel,autorizationModels} =this.props;
        autorizationModels(newOrderModel);
        $('#continueModal').modal('hide');  
    }
    render() {
       
        return (
                <div className="modal" tabIndex="-1" role="dialog" id="continueModal" >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        <div className="modal-body">
                            <p>¿Deseas continuar?</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white" onClick={this.Continue}> Si </button>
                            <button type="button" className="btn botonCorrect text-black" onClick={this.closeConfirm}>No</button>
                        </div>
                        </div>
                    </div>
                </div>
        );  
    }
}
export default ContinueModal;